import { QueryHookOptions, QueryResult, gql, useQuery } from '@apollo/client';
import { Query, QueryGetFileInstanceDownloadUrlArgs } from 'middleware-types';

const GET_FILE_INSTANCE_DOWNLOAD_URL = gql`
	query GetFileInstanceDownloadUrl($fileInstanceId: String!, $sasUrlOnly: Boolean!) {
		getFileInstanceDownloadUrl(fileInstanceId: $fileInstanceId, sasUrlOnly: $sasUrlOnly) {
			downloadUrl
			expiresUtc
		}
	}
`;

const checkFileExpiration = (
	result: QueryResult<
		Pick<Query, 'getFileInstanceDownloadUrl'>,
		QueryGetFileInstanceDownloadUrlArgs
	>
) => {
	const { data, loading, refetch } = result;
	if (loading) return;
	const expiresUtc = data?.getFileInstanceDownloadUrl.expiresUtc;
	if (!expiresUtc) return;
	const expiration = new Date(expiresUtc);
	if (new Date() > expiration) refetch();
};

export const useDownloadUrl = (
	options: QueryHookOptions<
		Pick<Query, 'getFileInstanceDownloadUrl'>,
		QueryGetFileInstanceDownloadUrlArgs
	>
) => {
	const result = useQuery<
		Pick<Query, 'getFileInstanceDownloadUrl'>,
		QueryGetFileInstanceDownloadUrlArgs
	>(GET_FILE_INSTANCE_DOWNLOAD_URL, options);
	checkFileExpiration(result);
	return result;
};
